import * as React from "react";
import { FormControlLabel, FormHelperText, FormControl } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

import { FieldRenderProps } from "react-final-form";
import { ChangeEvent, ReactElement } from "react";

interface ICheckboxFieldControl {
  label?: string | ReactElement;
  onChange: (state: boolean) => void;
  disabled?: boolean;
}

class CheckboxControl extends React.Component<FieldRenderProps & ICheckboxFieldControl> {
  constructor(props: FieldRenderProps & ICheckboxFieldControl) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  public render(): JSX.Element {
    const {
      input: { name, value },
      meta,
      disabled,
    } = this.props;
    const valueStr = value.toString();

    return (
      <FormControl error={true} variant="standard">
        <FormControlLabel
          control={
            <Checkbox
              name={name}
              checked={value}
              disabled={disabled}
              onChange={this.handleChange}
              value={valueStr}
              color="primary"
            />
          }
          label={this.props.label || ""}
        />
        {meta.touched && (meta.error || meta.submitError) && (
          <FormHelperText>{meta.error || meta.submitError}</FormHelperText>
        )}
      </FormControl>
    );
  }

  private handleChange(_e: ChangeEvent<HTMLInputElement>, checked: boolean) {
    if (checked) {
      this.props.input.onChange(true);
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    } else {
      this.props.input.onChange(false);
      if (this.props.onChange) {
        this.props.onChange(false);
      }
    }
  }
}

export default CheckboxControl;
